export const APP_TOKEN = 'token';
export const USER_ID = 'userId';
